import Icon from 'veui/components/Icon'
import { IconSync } from 'dls-icons-vue'

Icon.register('sync', IconSync)
